'use client';

import { lazy, Suspense, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button, Label, LoadingSpinner } from '@app/shared/ui/atoms/Common';
import { Popover, PopoverTrigger, PopoverContent } from '@app/shared/ui/molecules/Common';
const Calendar = lazy(() => import('./Calendar'));

interface DateOfBirthPickerProps {
  date?: Date;
  setDate: (date?: Date) => void;
  labelTranslationKey?: string;
}

export function DateOfBirthPicker({ date, setDate, labelTranslationKey }: DateOfBirthPickerProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col items-center gap-3">
      <Label htmlFor="date" className="px-1 text-center">
        {labelTranslationKey ? t(labelTranslationKey) : t('compatibility_calc.date_placeholder')}
      </Label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="custom"
            id="date"
            className="flex items-center gap-1 border-2 border-accent/50 px-3 text-accent"
          >
            {date ? date.toLocaleDateString() : t('common.select')}
            <ChevronDownIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto overflow-hidden p-0" align="start">
          <Suspense fallback={<LoadingSpinner containerClassName="p-3" />}>
            <Calendar
              mode="single"
              selected={date}
              captionLayout="dropdown"
              onSelect={(date) => {
                setDate(date);
                setOpen(false);
              }}
              disabled={(date) => date > new Date() || date < new Date('1900-01-01')}
            />
          </Suspense>
        </PopoverContent>
      </Popover>
    </div>
  );
}
